import { render, staticRenderFns } from "./OperaProblemsWindow.vue?vue&type=template&id=536d948b&"
import script from "./OperaProblemsWindow.vue?vue&type=script&lang=js&"
export * from "./OperaProblemsWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports